import HrModuleHost from "../../pages/hr/HrModuleHost";

const route = {
  key: "hrHost",
  path: "/hr/*",
  component: HrModuleHost,
  permission: "HR_EMPLOYEE_READ",
  private: true,
  layout: "main",
  icon: "faUsers",
  group: "hr",
  order: 10
};

export default route;
